export default "__VITE_ASSET__sv$I1Yu1__"